import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface ITextProps {
  theme: ITheme // TODO:VJ : default import setup to be done
  size: number
  padded: boolean
}

export const BText = styled('b')`
  label: BText;
  font-weight: 900;
`
export const SBText = styled(`h2`)<ITextProps>`
  label: SBText;
  font-weight: 800;
  font-size: ${(props) => (props.size ? props.size * 16 + 'px' : 'inherit')};
  padding: ${(props) => (props.padded ? '20px' : '')};
`
export const NText = styled('div')`
  label: NText;
  font-weight: 400 !important;
`
export const MediumText = styled('div')`
  label: MediumText;
  font-weight: 700;
`
export const SmallText = styled.div`
  label: SmallText;
  font-size: 14px;
`
